import { BuildDuration } from '../components/list-sidebar/types';

import {
  usePipelinesTimeseries,
  PipelinesTimeseries,
} from './use-pipelines-timeseries';
import {
  usePipelinesTimeseriesAverage,
  PipelinesTimeseriesAverage,
} from './use-pipelines-timeseries-average';

export type BuildDurationData = PipelinesTimeseriesAverage &
  PipelinesTimeseries & {
    data: BuildDuration[];
  };

const BUILD_DURATION_ENDPOINT = '/build/duration';

export function useBuildDuration(
  repositoryUuid?: string | null
): BuildDurationData {
  const { data, isLoading, error } = usePipelinesTimeseries(
    BUILD_DURATION_ENDPOINT,
    repositoryUuid
  );

  return {
    data,
    isLoading,
    error,
    ...usePipelinesTimeseriesAverage(data, 'duration'),
  };
}
